export default "__VITE_ASSET__DfGvroMN__"